import { Box, HStack, Icon, RippleButton, Text, Title, VStack } from "@repo/ui";
import { useTheme } from "@repo/tokens";
import { useTranslation } from "react-i18next";
import styles from "./UploadResultPopup.module.scss";
import { useIsMobile } from "@repo/utils";
import { TestModal } from "../TestModal";
import loading from "../../../../shared/assets/loading.gif";

type UploadPendingPopupProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const UploadPendingPopup = ({
  isOpen,
  onClose,
}: UploadPendingPopupProps) => {
  const { theme } = useTheme();
  const { t } = useTranslation("tests");
  const isMobile = useIsMobile();

  return (
    <TestModal
      isOpen={isOpen}
      onClose={onClose}
      dismissable={false}
      isOverlay={true}
      width="min(95vw, 40rem)"
      body={
        <VStack
          className={isMobile ? styles.uploadPendingPopupBody : styles.body}
        >
          <HStack justifyContent="flex-end" className={styles.closeBtn}>
            <RippleButton
              size="md"
              variant="text"
              shape="round"
              onPress={onClose}
              iconOnly
            >
              <Icon name="close" size={24} color={theme.colors.primary[40]} />
            </RippleButton>
          </HStack>
          <VStack alignItems="center" className={styles.pendingContent}>
            <Box className={styles.spinnerWrap}>
              <img src={loading} alt="" decoding="async" />
            </Box>

            <Title
              variant="h2"
              role="headline"
              size={isMobile ? "sm" : "md"}
              weight="medium"
              color={theme.colors.text[10]}
              marginTop={0}
              marginBottom={0}
              align="center"
              className={styles.pendingTitle}
            >
              {t("upload_answer_sheet_flow.pending_title")}
            </Title>

            <Text
              variant="body"
              size="large"
              align="center"
              weight="emphasized"
              color={theme.colors.neutral[20]}
              className={styles.pendingDescription}
            >
              {t("upload_answer_sheet_flow.pending_message")}
            </Text>
          </VStack>
        </VStack>
      }
    />
  );
};
